// extracted by mini-css-extract-plugin
export default {"backdrop":"MainBackdropV3_backdrop__lp8rV"};